import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Balloon } from '@/components/ui/Surface/Balloon';
import { CheckIcon } from '@/components/ui/SvgIcon/Variable/SvgIconComponents';
import { LinkText } from '@/components/ui/Typography/Body/LinkText';
import { Text } from '@/components/ui/Typography/Body/Text';
import { IconTextGroup } from '@/components/ui/Typography/IconText/IconTextGroup';
import { useBoolState } from '@/hooks/state/useBoolState';
/**
 * コンサルタント：案件メンバー一覧に表示する注釈コンポーネント
 * @param props
 * @constructor
 */
export const RfpProfessionalOneMemberListDescriptionBalloon = (props) => {
    const { className = '' } = props;
    /** 「閉じる」で表示切り替え可能 */
    const { boolState: isShowBalloon, changeFalse: hideBalloon } = useBoolState({
        initialState: true,
    });
    /** 説明文 */
    const descriptions = [
        'RFPの情報共有',
        '企業との質問回答や条件相談内容の共有',
        '提案内容の共同編集',
    ];
    if (!isShowBalloon) {
        return null;
    }
    return (_jsx(Balloon, Object.assign({ className: clsx(className), color: 'gray', direction: 'up', isRounded: true, position: 'start' }, { children: _jsxs("div", Object.assign({ className: 'p-12' }, { children: [descriptions.map((description) => (_jsxs(IconTextGroup, Object.assign({ className: 'mb-8', space: 'wide' }, { children: [_jsx(CheckIcon, { color: 'info', size: 'xs' }), _jsx(Text, Object.assign({ color: 'base', size: 'sm' }, { children: description }))] }), description))), _jsx("button", Object.assign({ className: clsx('group', 'flex', 'ml-auto'), onClick: hideBalloon, type: 'button' }, { children: _jsx(LinkText, Object.assign({ size: 'xs' }, { children: "\u9589\u3058\u308B" })) }))] })) })));
};
